export default "__VITE_ASSET__FIeYf9yw__"